import React from "react";

export const Navigation = (props) => {
  return (
       <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            <span><img src={props.data ? props.data.logo : "Cargando"} width="150" className="img-responsive img-logo" alt="" /></span>
            <span className="white">Pri</span><span className="red">disp</span>
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#features" className="page-scroll" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
                Características
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
                Nosotros
              </a>
            </li>
            <li>
              <a href="#services" className="page-scroll" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
                Servicios
              </a>
            </li>
            <li>
              <a href="#portfolio" className="page-scroll" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
                Productos
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
                Contacto
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
/*
<li>
<a href="#testimonials" className="page-scroll">
  Testimonials
</a>
</li>
<li>
<a href="#team" className="page-scroll">
  Team
</a>
</li>
*/